var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompetitorsLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394,
    height: 860.552,
    viewBox: "0 0 394 860.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041",
    transform: "translate(-763 -8648)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    y2: 290,
    transform: "translate(960.5 8648)",
    fill: "none",
    stroke: "#00bf5f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    y2: 290,
    transform: "translate(960.5 9218.552)",
    fill: "none",
    stroke: "#00bf5f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    transform: "translate(763 8881)",
    fill: "none",
    stroke: "#00bf5f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 197,
    r: 197,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 197,
    r: 196,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorsLine);
export default __webpack_public_path__ + "static/media/competitors_line.3713d7c0788c8ebed58bb5ee76e90bcd.svg";
export { ForwardRef as ReactComponent };